import { connect } from 'react-redux';
import type { ValuationPEGRatioProps } from '@/pages/CompanyReport/components/Value';
import { ValuationPEGRatioRawData } from '@/pages/CompanyReport/components/Value';
import { getSummary, getAnalysis } from '@/pages/CompanyReport/redux/selectors';
import { getAveragesSelector } from '@ducks/averages/selectors';
const mapStateToProps = (
  state,
  ownProps: { companyId?: string }
): ValuationPEGRatioProps => {
  const summary = getSummary(state, ownProps);
  const analysis = getAnalysis(state, ownProps);
  const { getIndustryAverage, getMarketAverage } = getAveragesSelector(
    state,
    ownProps
  );
  const industryPEG = getIndustryAverage('PEG');
  const marketPEG = getMarketAverage('PEG');
  return {
    uniqueSymbol: summary.uniqueSymbol,
    peValue: analysis.PE,
    pegValue: analysis.PEG,
    analystCount: summary.analystCount,
    futureNetIncomeGrowthAnnual: analysis.earningsGrowthAnnual,
    industryCountryName: industryPEG.source,
    industrySecondaryName: summary.industryData.secondaryName,
    industryAveragePEGCount: industryPEG.count,
    industryAveragePEG: industryPEG.value,
    marketCountryName: marketPEG.source,
    marketAveragePEGCount: marketPEG.count,
    marketAveragePEG: marketPEG.value,
  };
};

export default connect(mapStateToProps)(ValuationPEGRatioRawData);
